import { useQuery, useQueryClient } from "@tanstack/react-query";
import { PurchaseOrderService } from "src/services";
import { QueryParamsMapper } from "src/mappers/queryParamsMapper";
import { queryKeys } from "src/constants";
import { DateTimeRange, PurchaseOrderPaginationOptions } from "src/types";

interface UsePurchaseOrdersByBarcodeOptions {
  enabled?: boolean;
}

const usePurchaseOrdersByBarcode = (
  purchaseOrderService: PurchaseOrderService,
  dateTimeRange?: DateTimeRange,
  paginationOptions?: PurchaseOrderPaginationOptions,
  options: UsePurchaseOrdersByBarcodeOptions = {}
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getPurchaseOrdersByBarcodeQueryParams(dateTimeRange, paginationOptions);

  const {
    data: paginatedPurchaseOrders,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedPurchaseOrdersByBarcode(queryParams),
    queryFn: () => purchaseOrderService.getPurchaseOrdersByBarcode(queryParams),
    enabled: options.enabled ?? true
  });

  const refreshPurchaseOrders = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedPurchaseOrdersByBarcode(),
      exact: false
    });
  };

  return { paginatedPurchaseOrders, fetchError, isLoading, refreshPurchaseOrders };
};

export { usePurchaseOrdersByBarcode };
